<template>
  <div class="pagination">
    <el-pagination
      background
      :hide-on-single-page="count == 0"
      :page-sizes="[10, 20, 30, 50, 100]"
      :page-size="size"
      :current-page="Number(page)"
      :total="count"
      layout="prev, pager, next"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>
<!-- layout="total, sizes, prev, pager, next, jumper" -->
<script>
export default {
  name: 'Pagination',
  props: {
    page: { // 页数
      type: [Number,String],
      default: 1
    },
    size: { // 条数
      type: [Number,String],
      default: 10
    },
    count: { // 总数
      type: [Number,String],
      default: 0
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('update:size', val)
      this.$emit('change')
    },
    handleCurrentChange(val) {
      this.$emit('update:page', val)
      this.$emit('change')
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination{
  display: flex;
  align-items: center;
  justify-content: center;
  // position: absolute;
  // bottom: 60px;
  margin: auto 0;
  margin-top: 30px;
  overflow: hidden;
  width: 100%;
}
</style>
